import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";
import { extendObservable } from 'mobx';

import { Link } from "react-router-dom";

import QuantityList from './QuantityList'
import ProductList  from './ProductList'
import PriceList    from './PriceList'
import Header       from './Header'
import Footer       from './Footer'


@inject('core')
@observer
export default class Overview extends React.Component {
	
	constructor(props) {
		super(props)
		this.check_pod = this.check_pod.bind(this)
	}
	
	componentDidMount() {
		const { core, pod_id } = this.props
		
		this.check_pod(pod_id)
	}
	
	componentDidUpdate() {
		const { core, pod_id } = this.props
		
		this.check_pod(pod_id)
	}
	
	check_pod(pod_id) {
		const { core } = this.props
		if (pod_id != core.pod_id) {
			core.loadPod(pod_id)
		}
	}

	render() {
		const { core, children, pod_id, url } = this.props
		
		// console.log(url)
		
		if (pod_id == core.pod_id) {
			return <div id="pod">
				<Header path={url.match.path} />
				<div id="body">{children}</div>
				<Footer path={url.match.path} />
			</div>
		}
		return <div>Pod '{pod_id}' not loaded.</div>
	}
	
}
